import PortadorFinanceiroService from "@/services/PortadorFinanceiroService"

export const actions = {
    cadastrarPortadorFinanceiro: ({commit, dispatch}) => {
        commit('setPortadorFinanceiro', {
           nome:""
        }),
        dispatch('setModalCadastroPortadorFinanceiro', true)
    },
    listarPortadorFinanceiro: ({commit}, data) => {
        commit('setOverlay', true)
        PortadorFinanceiroService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setPortadoresFinanceiro', res.data)

        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarPortadorFinanceiro: ({commit, dispatch}, data) => {
        commit('setPortadorFinanceiro', data)
        dispatch('setModalCadastroPortadorFinanceiro', true)
    },
    
    salvarPortadorFinanceiro: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PortadorFinanceiroService.salvar(data)
        .then(res => {
            commit('setPortadorFinanceiro', res.data)
            commit('addPortadorFinanceiro', res.data)
            dispatch('setModalCadastroPortadorFinanceiro', false)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Registro salvo.')
            dispatch('setModalListarPortadorFinanceiro', false)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarPortadorFinanceiro: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PortadorFinanceiroService.atualizar(data)
        .then(res => {
            dispatch('listarPortadorFinanceiro')
            commit('setOverlay', false)
            commit('snackbarInfo', 'Registro atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirPortadorFinanceiro: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirPortadorFinanceiro', false)
        dispatch('setModalCadastroPortadorFinanceiro', false)
        commit('setOverlay', true)
        PortadorFinanceiroService.excluir(data.id)
        .then(res => {
            commit('removePortadorFinanceiro', res.data)
            commit('setOverlay', false)
            commit('snackbarError', 'Registro excluído.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    setModalCadastroPortadorFinanceiro: ({commit}, status) => {
        commit('setModalCadastroPortadorFinanceiro', false)
        setTimeout(() => {
            commit('setModalCadastroPortadorFinanceiro', status)
        }, 100);
    },
    setModalExcluirPortadorFinanceiro: ({commit}, status) => {
        commit('setModalExcluirPortadorFinanceiro', false)
        setTimeout(() => {
            commit('setModalExcluirPortadorFinanceiro', status)
        }, 100);
    },
    setModalListarPortadorFinanceiro: ({commit}, status) => {
        commit('setModalListarPortadorFinanceiro', false)
        setTimeout(() => {
            commit('setModalListarPortadorFinanceiro', status)
        }, 100);
    },
}

export default {}